const API_BASE = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE}Area`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function getAreas() {
  try {
    const res = await fetch(API_URL, {
      headers: getAuthHeaders()
    });
    
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error en getAreas:', error);
    throw error;
  }
}

export async function createArea(values) {
  try {
    await fetch(API_URL, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        nombre: values.nombre,
        descripcion: values.descripcion,
        estado: Number(values.estado)
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function editArea(id, values) {
  try {
    await fetch(`${API_URL}/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        nombre: values.nombre,
        descripcion: values.descripcion,
        estado: Number(values.estado)
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function deleteArea(id) {
  try {
    await fetch(`${API_URL}/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return true;
  } catch {
    return false;
  }
}
